import InfoIcon from "@/assets/icons/info.svg?react";
import { Typography } from "@/components/ui";
import useCUMechanicalJobStore from "@/store/useCUMechanicalJobStore";

import {
  AdditionalJobDetails,
  CheckedByDetails,
  Checks,
  ComponentDetails,
  ContactInformation,
  DefectDetails,
  DesignConditions,
  DesiredRepairType,
  DrawingNotes,
  EnclosureDetails,
  JointEfficiency,
  MdmtRevision,
  MechanicalJobDetails,
  MinimumClearance,
  PostConstructionTestingRequirements,
  SealDetails,
  StrongbackDetails,
  StrongbackTypeLocationDetails,
} from "../components";

interface JobFormSectionsProps {
  temperatureUnitsOptions: Array<{ title: string; value: string }>;
  shouldShowJointEfficiency: boolean;
}

export function JobFormSections({ temperatureUnitsOptions, shouldShowJointEfficiency }: JobFormSectionsProps) {
  const repairType = useCUMechanicalJobStore((state) => state.sections.repairType.data.repairType);
  // Strongback sections are hidden for the 90 (long_radius) flow for now. The backend can handle
  // a job with no strongback data at all, so nothing is submitted for it.
  const showStrongbackSections = repairType !== "long_radius";

  return (
    <>
      <div className="my-9 border-gray-200 border-b border-solid pb-5">
        <Typography variant="text-lg" weight="semibold">
          Main information
        </Typography>
        <div className="flex items-center gap-1">
          <InfoIcon />
          <Typography variant="text-small">Complete each stage of the form</Typography>
        </div>
      </div>
      <div className="flex flex-col gap-4 rounded bg-gray-150 py-6 md:px-6">
        <MechanicalJobDetails />
        <AdditionalJobDetails />
        <ContactInformation />
        <DesignConditions temperatureUnitsOptions={temperatureUnitsOptions} />
        <DesiredRepairType />
        <ComponentDetails />
        <DefectDetails />
        <EnclosureDetails />
        {showStrongbackSections && (
          <>
            <StrongbackDetails />
            <StrongbackTypeLocationDetails />
          </>
        )}
        <PostConstructionTestingRequirements />
        <SealDetails />
        <DrawingNotes />
        <Checks />
        <MinimumClearance />
        <MdmtRevision />
        <CheckedByDetails />
        {shouldShowJointEfficiency && <JointEfficiency />}
      </div>
    </>
  );
}
